/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:26:26
 * @LastEditTime: 2023-02-24 10:02:51
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\work-center\modules\approvalManageRouter.js
 * 审批管理
 */
import store from '@/store'
import { getlist } from '@/api/field'
import { getAllFields } from '@/api/field'
const approvalManageRouter = [
  // 审批中心
  {
    path: '/behaviorManage/approval-centre/:meta_type',
    name: 'behaviorManageApprovalCentre',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageApprovalCentre" */
      //   '@/views/behaviorManage/approvalCentre/approvalCentre.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageApprovalCentre" */
        '@/views/behavior-manage/work-center/approval-manage/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '审批管理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '审批中心',
      },
      2: {
        title: '全部审批',
        breadcrumb: [
          {
            title: '审批中心',
            name: 'behaviorManageApprovalCentre',
          },
        ],
      },
    },
  },
  // 审批中心 -- 审批详情 is_replace == 2 全部审批
  {
    path: '/behaviorManage/approval-details/:id/:type/:data_id/:is_replace/:json',
    name: 'behaviorManageApprovalDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageApprovalDetails" */
      //   '@/views/behaviorManage/approvalCentre/approvalDetails.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageApprovalDetails" */
        '@/views/behavior-manage/work-center/approval-manage/Detail.vue'
      ), //新迁移文件
    async beforeEnter(to, from, next) {
      if (to.query.cls) {
        await getAllFields(to.query.cls).then((res) => {
          if (0 === res.status) {
            let data = res.data
            if (
              store.state.accountInfo.quarterRow.is_admin == 1 ||
              store.state.accountInfo.quarterRow.is_attached_admin == 1
            ) {
              for (let item of data) {
                item.is_create = 1
                item.is_detail = 1
                item.is_edit = 1
                item.is_click = 1
                item.is_approval = 1
              }
            }
            store.commit('setClientAllFields', data)
          }
        })
        await getlist(to.query.cls).then((res) => {
          if (0 === res.status) {
            let data = res.data
            if (
              store.state.accountInfo.quarterRow.is_admin == 1 ||
              store.state.accountInfo.quarterRow.is_attached_admin == 1
            ) {
              for (let item of data.title_list) {
                item.is_create = 1
                item.is_detail = 1
                item.is_edit = 1
                item.is_click = 1
                item.is_approval = 1
              }
            }
            store.commit('setClientFields', res.data)
          }
        })
      }
      next()
    },
    meta: {
      SecondaryMenu: '审批管理', //二级菜单
      title: '审批详情',
      breadcrumb: [
        {
          title: '审批中心',
          name: 'behaviorManageApprovalCentre',
        },
      ],
    },
  },
  // 审批中心 自报审批详情
  {
    path: '/behaviorManage/approval-centre/dataReport-approval-details/:id/:meta_type',
    name: 'behaviorManageDataReportApprovalDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemAgentLevelDeploy" */
      //   '@/views/behaviorManage/approvalCentre/dataReportApprovalDetails.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"masterDataSystemAgentLevelDeploy" */
        '@/views/behavior-manage/work-center/approval-manage/SelfApprovalDetail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '审批管理', //二级菜单
      title: '审批中心',
      breadcrumb: [
        {
          title: '审批中心',
          name: 'behaviorManageApprovalCentre',
        },
      ],
    },
  },
]
export default approvalManageRouter
